const SPLIT_PAYMENT_METHODS = [
	'zaliczka + gotówka',
	'zaliczka + przelew',
	'Payu + gotówka',
	'Payu + przelew'
]

const SPLIT_CASH_REMAINDER_METHODS = ['zaliczka + gotówka', 'Payu + gotówka']

const SPLIT_TRANSFER_REMAINDER_METHODS = ['zaliczka + przelew', 'Payu + przelew']

const FULL_TRANSFER_TOTAL_METHODS = [
	...SPLIT_TRANSFER_REMAINDER_METHODS,
	'przelew',
	'przedpłata',
	'płatność allegro',
	'płatność Allegro Finance',
	'płatność Payu',
	'płatność Przelewy24'
]

export function hasSplitPayment(paymentMethod) {
	return SPLIT_PAYMENT_METHODS.includes(paymentMethod)
}

export function isSplitPaymentCashRemainder(paymentMethod) {
	return SPLIT_CASH_REMAINDER_METHODS.includes(paymentMethod)
}

export function countsTowardTransferTotal(paymentMethod) {
	return FULL_TRANSFER_TOTAL_METHODS.includes(paymentMethod)
}
